import loadRes from 'load-res'

export default function initAMap(config) {
    var { key, version, plugins } = config,
        url = `https://webapi.amap.com/maps?v=${version}&key=${key}`

    // 同步下载插件
    var pluginStr = plugins.map(v => 'AMap.' + v).join(',')
    if (pluginStr.length > 0) {
        url += `&plugin=${pluginStr}`
    }

    return loadRes([
        {
            url,
            mtype: 'js',
        },
    ])
}
